export const Targa = ({ value, size = "md", testId }) => {
  const big = size === "lg";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-stretch overflow-hidden rounded-[4px] border border-slate-800 bg-white shadow-sm ${big ? "h-10" : "h-7"}`}
    >
      <span className={`flex flex-col items-center justify-center bg-[#0039A6] text-white ${big ? "w-6" : "w-4"}`}>
        <span className={`${big ? "text-[8px]" : "text-[6px]"} leading-none text-yellow-300`}>★</span>
        <span className={`${big ? "text-[10px]" : "text-[7px]"} font-bold leading-none`}>I</span>
      </span>
      <span className={`flex items-center px-2 font-mono font-bold tracking-[0.15em] text-slate-900 ${big ? "text-xl" : "text-xs"}`}>
        {value || "—"}
      </span>
      <span className={`bg-[#0039A6] ${big ? "w-6" : "w-4"}`} />
    </span>
  );
};
